import React, {FC} from 'react'
import {SelectTagsModal} from "./selectTagsModal";
import {SelectTagsModalMobile} from "./selectTagsModalMobile";
import {LayoutConst} from "../../../core";
import {useBreakpoint} from '@brg/ui';
import {ThemeProvider} from "styled-components";
import {ApplicationTheme} from "../../themes";
import {AppTester} from "../../../supporting";
import { SelectTagsModalProps } from './types';

const SelectTagsModalContainer: FC<SelectTagsModalProps> = (props) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s);
    const isBooksGallllery = AppTester.isBooksGallllery();

    //todo Починить цвета тегов в AddittionalWhite
    const Wrapper = isBooksGallllery ? ThemeProvider : React.Fragment;

    return (<Wrapper theme={ApplicationTheme.white}>
        {isMobile ? <SelectTagsModalMobile {...props} /> : <SelectTagsModal {...props} />}
    </Wrapper>);
}

export default SelectTagsModalContainer;import React, {FC} from 'react'
import {SelectTagsModal} from "./selectTagsModal";
import {SelectTagsModalMobile} from "./selectTagsModalMobile";
import {LayoutConst} from "../../../core";
import {useBreakpoint} from '@brg/ui';
import {ThemeProvider} from "styled-components";
import {ApplicationTheme} from "../../themes";
import {AppTester} from "../../../supporting";
import { SelectTagsModalProps } from './types';

const SelectTagsModalContainer: FC<SelectTagsModalProps> = (props) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s);
    const isBooksGallllery = AppTester.isBooksGallllery();

    //todo Починить цвета тегов в AddittionalWhite
    const Wrapper = isBooksGallllery ? ThemeProvider : React.Fragment;

    return (<Wrapper theme={ApplicationTheme.white}>
        {isMobile ? <SelectTagsModalMobile {...props} /> : <SelectTagsModal {...props} />}
    </Wrapper>);
}

export default SelectTagsModalContainer;